import APIRequestState from './_util/api-request';
import {lazyInitialize, nonenumerable} from 'core-decorators';
import QS from 'qs';

class RequestToBookGetSlotsState extends APIRequestState {
  getRequest(urlParams) {
    return this.ctx.sdk.get(`/request-to-book/slots?${QS.stringify(urlParams)}`);
  }
}

class RequestToBookSlotSelectState extends APIRequestState {
  putRequest(params) {
    return this.ctx.sdk.patch(`/baskets/active/appointments/active/request-to-book/slots`, params);
  }
}

class RequestToBookWithdrawRequestState extends APIRequestState {
  postRequest(order_id, reason) {
    return this.ctx.sdk.post(`/appointments/${order_id}/request-to-book/withdraw`, {
      cancellationReason: reason,
    });
  }
}

class RequestToBook {
  @lazyInitialize @nonenumerable getSlots = new RequestToBookGetSlotsState(this.ctx);
  @lazyInitialize @nonenumerable slotSelect = new RequestToBookSlotSelectState(this.ctx);
  @lazyInitialize @nonenumerable withdrawRequest = new RequestToBookWithdrawRequestState(this.ctx);

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });
  }

  dispose() {}
}

export default RequestToBook;



// WEBPACK FOOTER //
// ./spa/state/request-to-book.jsx